import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuctionDetail } from '../../../../models';
import {
  AuthenticationService,
  AuctionService,
  LoaderService,
  EventBusService,
  CmsService,
} from '../../../../services';
import constants from '../../../../utility/constants';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-auction-registeration',
  templateUrl: './auction-registeration.component.html',
  styleUrls: ['./auction-registeration.component.css'],
})
export class AuctionRegisterationComponent implements OnInit {
  auctionCode: string;
  auctionInfo: AuctionDetail;
  registerForm: FormGroup;
  returnUrl: string = '/';
  isRegistered: boolean;
  content: string;
  readyToSpentMinAmount: number = constants.public.readyToSpentMin;
  readyToSpentMaxAmount: number = constants.public.readyToSpentMax;
  private subscriptions: Array<Subscription> = [];

  constructor(
    private authService: AuthenticationService,
    private auctionService: AuctionService,
    private router: Router,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private toastr: ToastrService,
    private eventBusService: EventBusService,
    private cmsService: CmsService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((param) => {
      this.returnUrl = param['returnTo'];
    });

    this.checkLoggedIn();

    this.isRegistered = false;

    this.route.params.subscribe((param) => {
      this.auctionCode = param['auctionCode'];
      this.getAuctionInfo();
    });

    this.getTandCs();
    this.formInitiate();
  }

  checkLoggedIn()
  {
    if (!this.authService.checkLoggedIn()) {
      this.goToLogin();
      return false;
    }
    return true;
  }

  formInitiate() {
    this.registerForm = new FormGroup({
      spending: new FormControl(null, [
        Validators.min(this.readyToSpentMinAmount),
        Validators.max(this.readyToSpentMaxAmount),
      ]),
      termsCheckBox: new FormControl(false, this.checkRequired.bind(this)),
    });
  }

  checkRequired(control: FormControl) {
    if (control.value === false) return { required: true };
    return null;
  }

  getAuctionInfo() {
    this.loader.showLoader(true);
    const auctionDetail = this.auctionService.getAuctionDetailByCode(this.auctionCode).subscribe(
      (res) => {
        this.auctionInfo = res;
        this.loader.showLoader(false);
      },
      (err) => {
        this.loader.showLoader(false);
        this.goToRedirectUrl();
      }
    );
    this.subscriptions.push(auctionDetail)
  }

  getTandCs() {
    const cmsPublic = this.cmsService
      .GetCmsPublic(constants.common.cmsPages.termsAndConditions)
      .subscribe((response) => (this.content = response));
      this.subscriptions.push(cmsPublic)
  }

  onSubmit() {
    if (this.registerForm.invalid) return;
    if (!this.checkLoggedIn()) return;
    this.loader.showLoader(true);
    let value = this.registerForm.value.spending;
    let termsCheck = this.registerForm.value.termsCheckBox;
    const registerAuction = this.auctionService
      .registerUserToAuction(this.auctionInfo.id, value, termsCheck)
      .subscribe(
        () => {
          this.isRegistered = true;
          this.toastr.success(
            `Successfully Registered for ${this.auctionInfo?.title}`,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
          this.loader.showLoader(false);
        },
        (err) => {
          this.isRegistered = false;
          this.loader.showLoader(false);
          this.toastr.error(
            err,
            constants.common.toast.errorTitle,
            constants.common.toast.config
          );
        }
      );
      this.subscriptions.push(registerAuction)
  }

  goToLogin() {
    this.openModalFile();
  }

  goToRedirectUrl() {
    this.router.navigateByUrl(this.returnUrl);
  }

  openModalFile(modalName: String = 'login') {
    this.eventBusService.notification.emit(modalName);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
